import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        if (!store.state.auth.loggedIn) {
            store
                .dispatch("auth/fetchUser")
                .then(() => {
                    next();
                })
                .catch(() =>
                    next({ name: "Login", query: { redirect: to.fullPath } })
                );
        } else {
            next();
        }
    } else {
        if (store.state.auth.loggedIn) {
            next({ name: "Home" });
        } else {
            next();
        }
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.admin)) {
        if (!store.state.auth.user.is_admin_reseller) {
            next({ name: "Home" });
        } else {
            next();
        }
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    if (
        to.matched.some(record => record.meta.auth) &&
        !to.path.includes("documentation") &&
        to.name !== "Inactive Reseller" &&
        to.name !== "Support" &&
        !store.state.auth.user.reseller_active
    ) {
        next({ name: "Inactive Reseller" });
    } else {
        next();
    }
});

export default router;
